<template>
	<div>
		<div class="novel-con-one" v-for="(item, index) in novelList" :key="index">
			<img :src="item.cover_pic" alt class="novel-con-one-left" @click="toWorks(item.id)" />
			<div class="novel-con-one-right">
				<h4 class="novel-con-one-right-head" @click="toWorks(item.id)">{{item.title}}</h4>
				<div class="novel-con-one-right-con">
					<div class="novel-con-one-right-con-div">
						<p>作者：{{item.author}}</p>
					</div>
					<div class="novel-con-one-right-con-div">
						<p>字数：{{item.wordnumber}}</p>
					</div>
					<div class="novel-con-one-right-con-div">
						<p v-if="item.status==1">
							状态：
							<span class="myspan">连载中</span>
						</p>
						<p v-if="item.status==2">
							状态：
							<span class="myspan1">已完成</span>
						</p>
					</div>
					<div class="novel-con-one-right-con-div">
						<p>
							题材：
							<span v-for="(citem,cindex) in item.bookcate" :key="cindex">{{citem}}</span>
						</p>
					</div>
				</div>
				<p class="myp">简介：</p>
				<div class="myintroduce">
					<p class="myintroduce-p">{{item.summary}}</p>
				</div>
				<div class="novel-con-one-right-foot" v-if="item.episodes.length>0">
					<div class="novel-con-one-right-foot-div">
						<p class="myp1">
							更新至：
							<span class="myspan1">{{item.episodes[0].title}}</span>
						</p>
						<p class="myp2">更新时间：{{item.episodes[0].create_time_text}}</p>
					</div>
					<div class="novel-con-one-right-foot-div" v-if="b=='1'">
						<button class="novel-con-one-right-foot-div-btn">开始阅读</button>
						<button class="novel-con-one-right-foot-div-btn1">加入收藏</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "App",
		props: ["b", "novelList"],
		components: {},
		data: {},
		methods: {
			toWorks(id) {
				const InfoDetail = this.$router.resolve({
					path: "/works",
					query: { id: id }
				});
				window.open(InfoDetail.href, "_blank");
			}
		}
	};
</script>

<style>
	.novel-con-one {
		width: 100%;
		display: flex;
		margin-top: 30px;
	}

	.novel-con-one-left {
		min-width: 140px !important;
		width: 140px !important;
		height: 220px;
		margin-right: 20px;
		border-radius: 8px;
		cursor: pointer;
	}

	.novel-con-one-right {
		position: relative;
	}
	.novel-con-one-right-head {
		color: #212121;
		font-size: 18px;
		cursor: pointer;
	}
	.novel-con-one-right-head:hover {
		color: #28a3b1;
	}

	.novel-con-one-right-head1 {
		color: #212121;
		font-size: 18px;
	}

	.novel-con-one-right-con {
		margin-top: 16px;
		display: flex;
	}

	.novel-con-one-right-con-div {
		display: flex;
		margin-right: 40px;
		font-size: 14px;
		line-height: 14px;
	}

	.myspan {
		color: #e51313;
	}
	.myspan1 {
		color: #808080;
	}

	.myp {
		font-size: 14px;
		margin-top: 10px;
	}

	.myintroduce {
		margin-top: 10px;
	}

	.myintroduce-p {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 4;
		overflow: hidden;
		font-size: 14px;
		color: #808080;
	}

	.novel-con-one-right-foot {
		display: flex;
		align-items: flex-end;
		font-size: 14px;
		position: absolute;
		bottom: 0;
		margin-top: 16px;
		justify-content: space-between;
		width: 100%;
	}
	.novel-con-one-right-foot-div {
		display: flex;
	}
	.novel-con-one-right-foot-div-btn {
		width: 90px;
		height: 30px;
		margin-right: 20px;
		background-color: #28a3b1;
		border-radius: 4px;
		color: #fff;
		border: 0;
		font-size: 14px;
	}
	.novel-con-one-right-foot-div-btn1 {
		width: 90px;
		height: 30px;
		border: 1px solid rgba(0, 0, 0, 1);
		border-radius: 4px;
		font-size: 14px;
		background-color: #fff;
		color: #212121;
	}
	.myspan1 {
		color: #28a3b1;
	}

	.myp1 {
		margin-right: 40px;
	}

	.myp2 {
		color: #808080;
		font-size: 14px;
	}
</style>



// WEBPACK FOOTER //
// src/components/publicnovul.vue